export default __webpack_public_path__ + "static/media/bg_account.8ad4420b.png";